var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'rounded-button',
    ("rounded-button--" + _vm.size)
  ],on:{"click":_vm.buttonAction}},[_c('span',{staticClass:"rounded-button__bg"}),_c('p',[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }